import * as React from 'react';
import styled from '@mui/material/styles/styled';
import { Grid, MobileStepper } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CoachType from './CoachType';
import TherapyTypes from './TherapyTypes';
import UploadProfilePicture from './UploadProfilePicture';
import SubscriptionPlan from './SubscriptionPlan';
import { clearClientSecret } from '../../redux/subscription/subscriptionSlice';
import { ONBOARDING_ROUTE } from '../../utils/routes';
import { useAppSelector } from '../../redux/hooks';
import AccountCreationComplete from './AccountCreationComplete';

const StyledStepper = styled(MobileStepper)(() => ({
  background: 'transparent',
  '& .MuiMobileStepper-dots': {
    alignItems: 'center',
  },
  '& .MuiMobileStepper-dot': {
    backgroundColor: '#FFDDC8',
    width: 8,
    height: 8,
  },
  '& .MuiMobileStepper-dotActive': {
    background: 'linear-gradient(175.46deg, #FEE4DB -9.81%, #FFAAA0 96.32%)',
    width: 12,
    height: 12,
  },
}));

export default function OnboardingWizard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isPrincipalCoach } = useAppSelector((state) => state.onboarding);
  const [activeStep, setActiveStep] = useState(0);
  const totalSteps = 4;

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const stepFromPath = parseInt(query.get('step') || '1', 10) - 1;
    setActiveStep(Math.max(0, Math.min(stepFromPath, totalSteps - 1)));

    if (stepFromPath === 3 && isPrincipalCoach) {
      dispatch(clearClientSecret());
    }
  }, [location.search, isPrincipalCoach, dispatch, totalSteps]);

  const handleNavigate = (direction) => {
    const nextStep = Math.max(0, Math.min(activeStep + direction, totalSteps - 1));
    navigate(`${ONBOARDING_ROUTE}?step=${nextStep + 1}`);
  };

  const steps = React.useMemo(
    () =>
      isPrincipalCoach
        ? [
            <CoachType key="coach-type" handleNext={() => handleNavigate(1)} />,
            <TherapyTypes
              key="therapy-type"
              handleBack={() => handleNavigate(-1)}
              handleNext={() => handleNavigate(1)}
            />,
            <UploadProfilePicture
              key="upload-picture"
              handleBack={() => handleNavigate(-1)}
              handleNext={() => handleNavigate(1)}
            />,
            <SubscriptionPlan key="subscription-plan" />,
          ]
        : [
            <CoachType key="coach-type" handleNext={() => handleNavigate(1)} />,
            <TherapyTypes
              key="therapy-type"
              handleBack={() => handleNavigate(-1)}
              handleNext={() => handleNavigate(1)}
            />,
            <UploadProfilePicture
              key="upload-picture"
              handleBack={() => handleNavigate(-1)}
              handleNext={() => handleNavigate(1)}
            />,
            <AccountCreationComplete key="account-creation-complete" />,
          ],
    [isPrincipalCoach, handleNavigate]
  );

  return (
    <Grid container justifyContent="center">
      <Grid item mb={2} xs={12}>
        {steps[activeStep]}
      </Grid>
      <Grid item container xs={12} justifyContent="center">
        <StyledStepper
          variant="dots"
          steps={totalSteps}
          position="static"
          activeStep={activeStep}
          nextButton={null}
          backButton={null}
        />
      </Grid>
    </Grid>
  );
}
